import {FormControl, FormHelperText, InputAdornment} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import React, {useEffect} from "react";
import Cookies from "js-cookie";
import {useTranslation} from "react-i18next";
import {CustomStyleFormHelperText, CustomStylePhoneInput} from "./Styles";
import {CustomTextField} from "./CustomTextField";
import {dateInputLanguage} from "../hooks/dateInputLanguage";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Phone Input
 * @param String id: Identifier for the phone number (required)
 * @param Boolean disabled: Enable/disable interaction with the phone number (optional)
 * @param Boolean required: Indicates if the phone number is required (optional)
 * @param String value: phone number value (required)
 * @param Boolean emptyFields: Indicates if the field is empty (optional)
 * @param Boolean isValid: Show legend and input with error when isValid = false (optional)
 * @param Event onChange: onChange trigger for the phone number (required)
 * @returns {JSX.Element}
 */
export const CustomPhoneInput = ({id="phoneNumber", disabled, required=false ,value, emptyFields,  isValid=true, onChange}) => {
    const { t } = useTranslation();
    const lCode = Cookies.get("i18next") || "en";

    const handleFocus = (action) => {
        let element = document.getElementById(id);
        let parent = element?.parentNode;
        let child = parent?.querySelector(".special-label");

        if(action === "ADD"){
            child?.classList.add("focused");
        }else{
            child?.classList.remove("focused");
        }
    }

    useEffect(()=>{

        let element = document.getElementById(id);
        let parent = element?.parentNode;
        let grandfather = parent?.parentNode;
        let child = parent?.querySelector(".special-label");
        if(emptyFields && (value === '' || value === null) || (!isValid && value !== '')){
            grandfather?.classList.add("error");
            child?.classList.add("error");
        }else{
            grandfather?.classList.remove("error");
            child?.classList.remove("error");
        }
    }, [emptyFields, isValid, value]);

    return (
        <>
            {
                !disabled ?
                    <FormControl fullWidth sx={CustomStylePhoneInput}>
                        <PhoneInput
                            localization={dateInputLanguage[lCode]}
                            inputProps={{
                                id:id,
                                name: 'phoneNumber',
                                required: required
                            }}
                            size="small"
                            fullWidth
                            name="phoneNumber"
                            containerClass={"mb-0"}
                            country='us'
                            value={value || ""}
                            enableSearch
                            enableTerritories
                            inputClass={disabled ? 'standard' : 'outlined'}
                            disabled={disabled}
                            onChange={(e) => {
                                onChange(e, "phoneNumber")
                            }}
                            onFocus={(e) => {
                                handleFocus("ADD");
                            }}
                            onBlur={(e) => {
                                handleFocus("REMOVE");
                            }}
                            InputProps={{
                                maxLength: 10
                            }}
                            searchPlaceholder={t("search")}
                            specialLabel={`${t('phone_number')}`}
                            className={required? 'required-phone': ''}
                        />
                    </FormControl> :
                    <CustomTextField
                        trans={t('phone_number')}
                        value={value || ""}
                        disabled={disabled}
                        required={required}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <PhoneIphoneIcon/>
                                </InputAdornment>
                            ),
                        }}
                    />
            }
            { (emptyFields && (value === '' || value === null)) &&
            <FormHelperText error={true} sx={CustomStyleFormHelperText}>
                {t('requiredField')}
            </FormHelperText>
            }

            { (!isValid &&  (value !== '' && value !== null)) &&
            <FormHelperText error={true} sx={CustomStyleFormHelperText}>
                {t('phone_number_format_invalid')}
            </FormHelperText>
            }
        </>
    )
}
